import storage from '../storage/index.js'


export const yxEncript=(str)=>{
    function base64Encode(input) {
      var rv;
      rv = encodeURIComponent(input);
      rv = unescape(rv);
      rv = window.btoa(rv);
      return rv;
    }
    var result = base64Encode(str);
    result = result.split('').reverse().join('');
    return result;
}

export const yxDecript=(str)=>{
    var result = str.split('').reverse().join('');
    function base64Decode(input) {
      var rv = window.atob(input);
      rv = escape(rv);
      rv = decodeURIComponent(rv);
      return rv;
    }
    return base64Decode(result);
}

export const getUrlArgument=(name)=>{
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null)
        return decodeURI(r[2]);
    return null;
}

export const getCss=(obj,attr)=>{
    var i = parseFloat(
        obj.currentStyle
        ? obj.currentStyle[attr]
        : document.defaultView.getComputedStyle(obj, false)[attr]);
    var values = i
        ? i
        : 0;
    if (attr == "opacity") {
        values = Math.round(values * 100);
    }
    return values;
}

export const strlen=(str)=>{
    var len = 0;
    for (var i=0; i<str.length; i++) {
     var c = str.charCodeAt(i);
    //单字节加1
     if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
       len++;
     }
     else {
      len+=2;
     }
    }
    return len;
}

export const loadImages=(id,fn)=>{
    var allImg = document.getElementById(id).getElementsByTagName('img');
    var imgSrcArr = [];
    var imgSuc = 0;
    var imgTimer = '';
    var allImgNum = 0
    for (var i = 0; i < allImg.length; i++) {
        if (allImg[i].src && allImg[i].src.indexOf('base64') < 0 && allImg[i].src.indexOf('images') > 0) {
            allImgNum++
            imgSrcArr.push(allImg[i].src)
        }
    }
    for (var i = 0; i < allImgNum; i++) {
        var oImg = new Image();
        oImg.src = imgSrcArr[i];
        oImg.onload = () => {
            imgSuc++;
            // console.log(imgSuc ,allImgNum);
            if (imgSuc == allImgNum) {
                clearTimeout(imgTimer)
                imgTimer = setTimeout(() => {
                    if (fn) fn.call(this)
                }, 100)
            }
        }
    }
}

export const os=()=>{
    var ua = window.navigator.userAgent
    var isWeibo = (/WeiBo/i).test(ua),
        isQQ = (/QQ/i).test(ua),
        isWechat = (/MicroMessenger/i).test(ua),
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isIos = /(?:iPhone)/.test(ua) && !isTablet,
        isBrowser = !isWeibo && !isQQ && !isWechat,
        isPc= !isWeibo && !isQQ && !isWechat && !isAndroid && !isIos;
    return {
        isWeibo: isWeibo,
        isQQ: isQQ,
        isWechat: isWechat,
        isAndroid: isAndroid,
        isIos: isIos,
        isTablet: isTablet,
        isBrowser: isBrowser,
        isPc:isPc
    }
}

//图片转base64
export const convertImgTobase64=(url, callback, outputFormat)=>{
    var canvas = document.createElement('CANVAS'),
        ctx = canvas.getContext('2d'),
        img = new Image;
    img.crossOrigin = 'Anonymous';
    img.onload = function() {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || 'image/png');
        callback.call(this, dataURL);
        canvas = null;
    };
    img.src = url;
}

//过滤字段
export const filterData=(json)=>{
    for(var attr in json){
        if(json[attr]==='' || json[attr]===undefined){
            delete json[attr];
        }
    }
    return json;
}

//获取服务器时间
export const headTime=(fn)=>{
    var xhr = new XMLHttpRequest()
    // xhr.open('HEAD',location.href,true)
    xhr.open("get", "/");
    // xhr.onreadystatechange=function(){
    //     console.log(xhr);
    //     if( xhr.readyState == 4 && xhr.status == 200 ){
    //         var time = (xhr.getResponseHeader('Date'))
    //         var curDate = new Date(time)
    //         var localTime = curDate.getTime()
    //         var localOffset=curDate.getTimezoneOffset()*60000//获得当地时间偏移的毫秒数
    //         var utc = localTime + localOffset//utc即GMT时间
    //         var offset =8//以夏威夷时间为例，东10区
    //         var hawaii = utc + (3600000*offset)
    //         curDate = new Date(hawaii)
    //         if(fn) fn.call(this,curDate.getTime())
    //         console.log("服务器时间是：" + curDate.getFullYear() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getDate() + " " + curDate.getHours() + ":" + curDate.getMinutes() + ":" + curDate.getSeconds());
    //     }
    // }
    xhr.onreadystatechange = ()=>{
        var time = null,
            curDate = null;
        if (xhr.readyState === 2) {
            // 获取响应头里的时间戳
            time = xhr.getResponseHeader("Date");
            // console.log(xhr.getAllResponseHeaders())
            curDate = new Date(time);
            if(fn) fn.call(this,curDate.getTime())
            // console.log("服务器时间是：" + curDate.getFullYear() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getDate() + " " + curDate.getHours() + ":" + curDate.getMinutes() + ":" + curDate.getSeconds());
        }
    }
    xhr.send(null)
}

//URL
export const editHistoryUrl = (str) => {
    var url=window.location.href
    url=url.substring(0,url.lastIndexOf('/')+1)
    url=url+str
    window.history.pushState('','',url)
}

//金额格式化
export const toThousands = (num) => {
    return (num || 0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1,')
}

//获取当前时间, yyyy-mm-dd hh-mm-ss
export const getNow = () => {
    let date = new Date()
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
    let D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' '
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    let s = (date.getSeconds() < 10 ? '0'+ date.getSeconds() : date.getSeconds())
    let now = Y + M + D + h + m + s
    return now
}

export const randomString = (len) => {
    len = len || 6
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZ2345678'    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd + Date.now()
}

/* eslint-disable */
//金额格式化
export const moneyFormat = (nStr) => {
    if (nStr === 0 || nStr === "0") {
        return "0.00";
    }

    if (!nStr || isNaN(nStr)) {
        return "";
    }

    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '.00';
    if (x2.length < 3) {
        x2 += "00";
    }
    x2 = x2.substring(0, 3);
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
};

/**
 * 对日期进行格式化
 * @param date 要格式化的日期
 * @param format 进行格式化的模式字符串
 *     支持的模式字母有：
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
export const dateFmt = (date, format) => {
    if ('number' === typeof date) {
        date = new Date(date);
    }
    if(format === undefined){
        format = date;
        date = new Date();
    }
    let map = {
        'M': date.getMonth() + 1, //月份
        'd': date.getDate(), //日
        'h': date.getHours(), //小时
        'm': date.getMinutes(), //分
        's': date.getSeconds(), //秒
        'q': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function(all, t){
        var v = map[t];
        if(v !== undefined){
            if(all.length > 1){
                v = '0' + v;
                v = v.substr(v.length-2);
            }
            return v;
        }
        else if(t === 'y'){
            return (date.getFullYear() + '').substr(4 - all.length);
        }
        return all;
    });
    return format;
};

/**
 * 判断网页是否是在微信内嵌浏览器中打开
 * @returns {boolean}
 */
export const isWeixinBrowser = () => {
    return (/MicroMessenger/i).test(window.navigator.userAgent);
};

/**
 * 设置document.title
 * @param title
 */
export const setTitle = (title) => {
    setTimeout(function(){
        //利用iframe的onload事件刷新页面
        document.title = title;
        var iframe = document.createElement('iframe');
        iframe.src = '1px4wx.gif';
        iframe.onload = function () {
            setTimeout(function () {
                document.body.removeChild(iframe);
            }, 0);
        };
        document.body.appendChild(iframe);
    },0);
    // if (isWeixinBrowser()) {
    //     setTimeout(function(){
    //         //利用iframe的onload事件刷新页面
    //         document.title = title;
    //         var iframe = document.createElement('iframe');
    //         iframe.src = '1px4wx.gif';
    //         iframe.onload = function () {
    //             setTimeout(function () {
    //                 document.body.removeChild(iframe);
    //             }, 0);
    //         };
    //         document.body.appendChild(iframe);
    //     },0);
    // } else {
    //     document.title = title;
    // }
};

/**
 * 检查对象是否为空
 * @author  Richie
 * @param {Object} obj 对象
 * @returns {boolean}
 */
export const isEmpty = (obj) => {
    if (!obj) return true;

    for(var i in obj){
        if(obj.hasOwnProperty(i)){
            return false;
        }
    }
    return true;
};

/**
 * 根据银行Code匹配银行名称
**/
export const getBankName = (bankcode) => {
    if(!bankcode) return '';
    switch (bankcode){
        case 'ICBC' :
            return '工商银行';
        case 'ABC' :
            return '农业银行';
        case 'BOC' :
            return '中国银行';
        case 'CCB' :
            return '建设银行';
        case 'BCM' :
            return '交通银行';
        case 'CITIC' :
            return '中信银行';
        case 'CEB' :
            return '光大银行';
        case 'HXB' :
            return '华夏银行';
        case 'CMBC' :
            return '民生银行';
        case 'PINGAN' :
            return '平安银行';
        case 'CMB' :
            return '招商银行';
        case 'CIB' :
            return '兴业银行';
        case 'SPDB' :
            return '浦发银行';
        case 'PSBOC' :
            return '邮储银行';
        case 'GDB' :
            return '广发银行';
        case 'BOS' :
            return '上海银行';
        case 'BOB' :
            return '北京银行';
    }

}

/**
 * 获取当前url中的参数
**/
export const getRequest = (str) => {
    let url = window.location+'' //获取url中"?"符后的字串
    if (str) {
        url = str
    }
    url = decodeURIComponent(url)

    let theRequest = new Object()

    let index = url.indexOf('?')

    if (index != -1) {
        let str = url.substr(index + 1)
        let strs = str.split('&')
        for(let i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
    }
    return theRequest
}

// 转义html标签
export const HTMLEncode=(html)=>{
    var temp = document.createElement("div");
    (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
    var output = temp.innerHTML;
    temp = null;
    return output;
}

export const HTMLDecode=(html)=>{
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
}

export const getParam = (str, name) => {
    let match = name + '='
    let i = str.indexOf(name + '=') + match.length
    let r = str.substr(i);
    return r
}

export function getComputedStyle (el, key) {
    let computedStyle = window.getComputedStyle(el)
    return computedStyle[key] || ''
}


export const respHandle =  (resp) => {
    //请求错误
    if (!resp.ok ) {
        return -1
    }
    if (resp.status == '200') {
        //调用后端服务正常，获得返回结构体
        if (resp.body.status == '200') {
            return 0
        }
        //用户登录失效
        if (resp.body.status == '504') {
            let phone = store.get('_phoneNo')
            store.init()
            if (phone == '' || phone == 'null' || !phone) {
                window.location.hash = '#!/hello'
                return 4
            }
            store.set({
                _phoneNo: phone
            })
            window.location.hash = '#!/login'
            return 3
        }
        //调用后端服务，系统异常
        return 1
    }
    //调用后端服务失败
    else {
        return 2
    }
}



// WEBPACK FOOTER //
// ./src/utils/tool.js